import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, MessageCircle, CalendarClock } from "lucide-react";
import { CONTACT, waLink } from "@/lib/brand";

/**
 * Mobile-only sticky action bar with three high-intent CTAs:
 *   Call, WhatsApp, Book Consultation.
 * Hides on the portal, admin, and auth routes to avoid clutter, and
 * respects safe-area inset on iOS.
 */
const HIDE_ON_PREFIXES = ["/portal", "/admin", "/login", "/register", "/set-password", "/partner-registration"];

export default function MobileStickyBar() {
    const { pathname } = useLocation();
    if (HIDE_ON_PREFIXES.some((p) => pathname.startsWith(p))) return null;

    const wa = waLink("Hi EBG Realty, I'm exploring properties on your website and would like to speak with an advisor.");

    return (
        <div
            data-testid="mobile-sticky-bar"
            className="lg:hidden fixed inset-x-0 bottom-0 z-40 border-t border-black/10 bg-white/95 backdrop-blur-xl shadow-[0_-8px_30px_-10px_rgba(0,0,0,0.25)]"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
            <div className="grid grid-cols-[1fr_1fr_1.45fr]">
                <a
                    href={CONTACT.tel}
                    data-testid="mobile-sticky-call"
                    className="flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] uppercase tracking-[0.2em] font-bold text-black hover:bg-black/[0.03] transition-colors"
                >
                    <Phone size={16} className="text-[var(--ebg-gold)]"/>
                    Call
                </a>
                <a
                    href={wa}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="mobile-sticky-whatsapp"
                    className="flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] uppercase tracking-[0.2em] font-bold text-black hover:bg-black/[0.03] transition-colors border-x border-black/10"
                >
                    <MessageCircle size={16} className="text-emerald-600"/>
                    WhatsApp
                </a>
                <Link
                    to="/contact"
                    data-testid="mobile-sticky-consult"
                    className="min-w-0 px-1 flex flex-col items-center justify-center gap-1 py-2.5 text-[9.5px] min-[375px]:text-[10px] uppercase tracking-[0.08em] min-[375px]:tracking-[0.12em] font-bold whitespace-nowrap bg-[var(--ebg-gold)] text-black hover:bg-black hover:text-[var(--ebg-gold)] transition-colors"
                >
                    <CalendarClock size={16}/>
                    Book Consultation
                </Link>
            </div>
        </div>
    );
}
